// extracted by mini-css-extract-plugin
export default {"dark":"Checkbox__dark","isSelected":"Checkbox__isSelected","check":"Checkbox__check","circle":"Checkbox__circle","mouseoverCheck":"Checkbox__mouseoverCheck"};